module.exports = __webpack_public_path__ + "static/media/write.00199158.png";